// Label constants for display
export const JOB_STATUS_LABELS = {
    not_started: "New Project",
    new_project: "New Project",
    in_progress: "In Progress",
    scheduled: "Scheduled",
    on_hold: "On Hold",
    completed: "Completed",
    invoiced: "Invoiced",
    cancelled: "Cancelled",
};
export const TRADE_TYPE_LABELS = {
    fire_services_wet: "Fire Services (Wet)",
    fire_services_dry: "Fire Services (Dry)",
    electrical: "Electrical",
    hydraulics: "Hydraulics",
    defit: "Defit",
    floor_grinding: "Floor Grinding",
    plasterer: "Plasterer",
    tiling: "Tiling",
    painting: "Painting",
    carpentry: "Carpentry",
};
/** Encumbered trade types (external contractors); used in admin and contractor portal. */
export const ENCUMBERED_TRADE_TYPES = [
    "fire_services_wet",
    "electrical",
    "fire_services_dry",
    "hydraulics",
    "tiling",
];
